import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../index';

function changePasswordSuccess(draft: Draft<IAuthData>) {
  draft.changePassword.config.isLoading = false;
}

export default changePasswordSuccess;
